/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const CallHangup = ({ className, color, onClick }) => {
  const classes = useStyles();

  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      onClick={onClick}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#EF4444" />
      <path
        d="M39.0004 28.3304V31.2504C38.9996 31.3646 38.9726 31.4771 38.9217 31.5793C38.8708 31.6816 38.7972 31.7708 38.7065 31.8403C38.6158 31.9097 38.5105 31.9575 38.3985 31.9801C38.2865 32.0026 38.1709 31.9993 38.0604 31.9704L33.7404 30.8404C33.5222 30.7818 33.3303 30.651 33.196 30.4695C33.0616 30.2879 32.9927 30.0661 33.0004 29.8404V26.6804C33.0021 26.5718 32.9676 26.4657 32.9025 26.3788C32.8373 26.292 32.7451 26.2292 32.6404 26.2004L31.9304 26.0004C29.3655 25.2402 26.6353 25.2402 24.0704 26.0004L23.3604 26.2204C23.2557 26.2492 23.1635 26.312 23.0983 26.3988C23.0332 26.4857 22.9987 26.5918 23.0004 26.7004V29.8804C23.0081 30.1061 22.9392 30.3279 22.8048 30.5095C22.6705 30.691 22.4786 30.8218 22.2604 30.8804L17.9404 32.0004C17.8274 32.03 17.7091 32.0329 17.5948 32.0087C17.4806 31.9846 17.3735 31.9341 17.2822 31.8612C17.1909 31.7884 17.1179 31.6952 17.069 31.5892C17.0201 31.4831 16.9966 31.3671 17.0004 31.2504V28.3404C17.0002 28.0765 17.0522 27.8151 17.1535 27.5714C17.2547 27.3277 17.4032 27.1064 17.5904 26.9204L18.0904 26.4204C19.2597 25.2522 20.6988 24.3901 22.2804 23.9104L22.7804 23.7604C26.1905 22.7504 29.8203 22.7504 33.2304 23.7604L33.7204 23.9104C35.3021 24.3901 36.7411 25.2522 37.9104 26.4204L38.4104 26.9204C38.786 27.2937 38.9982 27.8008 39.0004 28.3304Z"
        fill="white"
      />
    </svg>
  );
};

export default CallHangup;
